import phoneIcon from '../assets/footer/phone.png';
import mailIcon from '../assets/footer/mail.png';
import geoIcon from '../assets/footer/geo.png';
import clockIcon from '../assets/footer/clock.png';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useRevealOnScroll from '../hooks/useRevealOnScroll';

export default function Footer({ onContactClick }) {
  const { t } = useTranslation('footer');
  const [revealRef, isVisible] = useRevealOnScroll();

  return (
    <footer id="contacts" className="bg-[#0b1120] text-white">
      <div ref={revealRef} className={`reveal ${isVisible ? 'is-visible' : ''}`}>
      {/* CTA-полоса */}
      <div className="relative overflow-hidden border-b border-white/10">
        <div className="grid-bg" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-start gap-4">
            <img src={logo} alt="АскомМЕТ" className="h-12 w-auto shrink-0" />
            <div>
              <h2 className="font-display text-xl sm:text-2xl font-extrabold bg-gradient-to-r from-[#0070d2] to-[#00c2ff] bg-clip-text text-transparent">
                {t('company.name')}
              </h2>
              <p className="font-display text-sm font-semibold text-cyan-300 mb-2">
                {t('company.slogan')}
              </p>
              <p className="text-gray-400 max-w-md text-sm">
                {t('company.description')}
              </p>
            </div>
          </div>
          <button
            onClick={onContactClick}
            className="font-display btn-primary shrink-0"
          >
            {t('company.contact_button')}
          </button>
        </div>
      </div>

      {/* Контакты и услуги */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-10 text-left">
        <div>
          <h2 className="font-display text-xl font-bold mb-4">{t('contacts.title')}</h2>
          <ul className="text-gray-300 space-y-4">
            <li className="flex items-start gap-3">
              <img src={phoneIcon} alt="Phone" className="w-6 h-6 mt-1" />
              <div>
                <p className="text-white font-semibold">+7 (7172) 532 707</p>
                <p className="text-white font-semibold">+7 (701) 357 82 01</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <img src={mailIcon} alt="Email" className="w-6 h-6 mt-1" />
              <div>
                <p className="text-white font-semibold">info@askommet.kz</p>
                <p className="text-sm text-gray-400">{t('contacts.general')}</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <img src={geoIcon} alt="Address" className="w-6 h-6 mt-1" />
              <div>
                <p className="text-white font-semibold">{t('contacts.city')}</p>
                <p className="text-sm text-gray-400">{t('contacts.address')}</p>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <img src={clockIcon} alt="Hours" className="w-6 h-6 mt-1" />
              <div>
                <p className="text-white font-semibold">{t('contacts.hours')}</p>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-xl font-bold mb-4">{t('services.title')}</h2>
          <ul className="text-gray-300 grid grid-cols-1 sm:grid-cols-2 gap-2">
            <li><Link to="/video" className="hover:text-white transition">{t('services.video')}</Link></li>
            <li><Link to="/localsystems" className="hover:text-white transition">{t('services.localsystems')}</Link></li>
            <li><Link to="/antiterror" className="hover:text-white transition">{t('services.antiterror')}</Link></li>
            <li><Link to="/digitalforensics" className="hover:text-white transition">{t('services.digitalforensics')}</Link></li>
            <li><Link to="/drones" className="hover:text-white transition">{t('services.drones')}</Link></li>
            <li><Link to="/antidrone" className="hover:text-white transition">{t('services.antidrone')}</Link></li>
            <li><Link to="/sts" className="hover:text-white transition">{t('services.sts')}</Link></li>
          </ul>
        </div>
      </div>

      {/* Нижняя строка */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-sm text-gray-400 flex flex-col md:flex-row justify-between items-center">
          <p>{t('bottom.copyright')}</p>
        </div>
      </div>
      </div>
    </footer>
  );
}
